export default __webpack_public_path__ + "static/media/antiExplosion.dd9aa17e.svg";